module.exports = __webpack_public_path__ + "static/media/speakerIcon.a2bceee5.svg";